import { Pipe, PipeTransform } from '@angular/core';
import { OffCanvasComponents } from '../off-canvas-service/off-canvas-form.service';
import {  OptimaOffCanvasService } from '@optima-stride-ai/optima-components';

@Pipe({
  name: 'formSelector',
  standalone: true
})
export class FormSelectorPipe implements PipeTransform {
  transform(lvl: number, service: OptimaOffCanvasService, comp2: OffCanvasComponents): boolean {
    // console.log(`[Pipe-FormSelector] Current component in offCanvas is set to ${getKeyOfEnumValue(service.getLastOffCanvasAtLevel(lvl)?.componentInOffCanvas, OffCanvasComponents)}`);
    const decision = service.getLastOffCanvasAtLevel(lvl)?.componentInOffCanvas == comp2;
    return decision;
  }
}

